/**
 * Language detection utility
 * Detects whether text is Hebrew or English
 */

export type SupportedLanguage = 'he' | 'en';

/**
 * Detect the language of the given text
 * @param text - The text to analyze
 * @returns 'he' for Hebrew, 'en' for English (default)
 */
export function detectLanguage(text: string): SupportedLanguage {
  if (!text || text.trim().length === 0) {
    return 'en'; // Default to English for empty text
  }

  // Hebrew Unicode range: \u0590-\u05FF
  const hebrewRegex = /[\u0590-\u05FF]/;

  // If text contains Hebrew characters, it's Hebrew
  if (hebrewRegex.test(text)) {
    return 'he';
  }

  // Default to English
  return 'en';
}
